import React, { useState, useEffect, useMemo } from "react";
import api from "../utils/axiosConfig";
import localforage from "localforage";
import "../css/momData.css";
import { Link, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import Dashboard from "./Dashboard";
import data from "../dataFile.json";
import ReactPaginate from "react-paginate";
import DashboardReport from "./DashboardReport";

const API_URL = process.env.REACT_APP_API_URL;

const Report = () => {
  const [momData, setMomData] = useState([]);
  const [responseAllMomCount, setResponseAllMomCount] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zoneCount, setZoneCount] = useState(0);
  const [pcCount, setPcCount] = useState(0);
  const [acCount, setAcCount] = useState(0);
  const [partyCounts, setPartyCounts] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [form20DocumentCount, setForm20DocumentCount] = useState("");
  const [documentCount, setDocumentCount] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const initialDropdownValue = "";
  const [searchInput, setSearchInput] = useState("");
  const [filteredMomData, setFilteredMomData] = useState([]);

  const [selectedPc, setSelectedPc] = useState(initialDropdownValue);
  const [selectedConstituency, setSelectedConstituency] =
    useState(initialDropdownValue);
  const [selectedZone, setSelectedZone] = useState(initialDropdownValue);
  const navigate = useNavigate();

  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "desc",
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);

  const [filteredDocumentCount, setFilteredDocumentCount] = useState(0);
  const [filteredForm20DocumentCount, setFilteredForm20DocumentCount] =
    useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const pageCount = Math.ceil(filteredMomData.length / itemsPerPage);

  const displayedMomData = useMemo(() => {
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredMomData.slice(startIndex, endIndex);
  }, [currentPage, filteredMomData]);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const storedRole = await localforage.getItem("role1");
        if (storedRole) {
          setRole(storedRole);
        } else {
          console.log("Role not found in localforage.");
        }
      } catch (error) {
        console.error("Error fetching role:", error);
      }
    };

    fetchUserRole();
  }, []);

  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const storedLocation = await localforage.getItem("location");
        if (storedLocation) {
          setLocation(storedLocation);
        } else {
          console.log("Location not found in localforage.");
        }
      } catch (error) {
        console.error("Error fetching role:", error);
      }
    };

    fetchUserLocation();
  }, []);

  const filterMomDataByDateRange = (start, end) => {
    const filteredMomDataByDate = momData.filter(
      (mom) => new Date(mom.dom) >= start && new Date(mom.dom) <= end
    );

    setFilteredMomData(filteredMomDataByDate);
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handleSort = (key) => {
    requestSort(key);
    const sortedFilteredMomData = [...filteredMomData].sort((a, b) => {
      const valA = a[key].toUpperCase();
      const valB = b[key].toUpperCase();

      if (sortConfig.direction === "asc") {
        return valA.localeCompare(valB);
      } else {
        return valB.localeCompare(valA);
      }
    });
    setFilteredMomData(sortedFilteredMomData);
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig.key) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const handleSearchInputChange = (e) => {
    const input = e.target.value;
    setSearchInput(input);

    const filteredAndSortedData = sortedMomData.filter((mom) => {
      const tagsMatch = mom.tags.some((tag) =>
        tag.toLowerCase().includes(input.toLowerCase())
      );

      return (
        mom.constituency.toLowerCase().includes(input.toLowerCase()) ||
        mom.district.toLowerCase().includes(input.toLowerCase()) ||
        mom.pc.toLowerCase().includes(input.toLowerCase()) ||
        tagsMatch
      );
    });

    setFilteredMomData(
      [...filteredAndSortedData].sort((a, b) => {
        if (sortConfig.key) {
          const valA = a[sortConfig.key].toUpperCase();
          const valB = b[sortConfig.key].toUpperCase();

          return sortConfig.direction === "asc"
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        }

        return 0;
      })
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await localforage.getItem("token");
        const userId = await localforage.getItem("ID");

        // Punjab users don't have Political Reports data — show an empty folder
        // (no Andhra Pradesh data leaks into the Punjab experience).
        const loc = await localforage.getItem("location");
        if (loc === "Punjab") {
          setMomData([]);
          setFilteredMomData([]);
          setLoading(false);
          return;
        }

        const partyNames = [
          "Shivsena",
          "BJP",
          "UBT",
          "NCP(AP)",
          "NCP(SP)",
          "MVA",
          "INC",
          "MNS",
          "Other Party",
          "NA",
        ];

        const role = await localforage.getItem("role");
        setUserRole(role);

        const momDataResponse = await api.get(
          `${API_URL}/report/get-report/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const sortedMomData = momDataResponse.data.sort((a, b) => {
          if (a.pc < b.pc) return -1;
          if (a.pc > b.pc) return 1;
          if (a.constituency < b.constituency) return -1;
          if (a.constituency > b.constituency) return 1;
          return 0;
        });

        setMomData(sortedMomData);
        setFilteredMomData(sortedMomData);
        const momDataForAllParties = partyNames.map((partyName) => {
          const momCount = sortedMomData.filter(
            (mom) => mom.partyName === partyName
          ).length;
          return {
            partyName,
            momCount,
          };
        });

        setPartyCounts(momDataForAllParties);
        setResponseAllMomCount(sortedMomData.length);
        setLoading(false);

        const uniquePc = [...new Set(sortedMomData.map((mom) => mom.pc))];
        const uniqueAc = [
          ...new Set(sortedMomData.map((mom) => mom.constituency)),
        ];
        const uniqueZone = [...new Set(sortedMomData.map((mom) => mom.zone))];
        setDropdownData({
          ...dropdownData,
          pc: uniquePc,
          ac: uniqueAc,
          zone: uniqueZone,
        });
      } catch (error) {
        console.error("Error fetching mom data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [sortConfig]);

  useEffect(() => {
    const fetchUserEmail = async () => {
      try {
        const storedEmail = await localforage.getItem("email");
        if (storedEmail) {
          setEmail(storedEmail);
        } else {
          console.log("Email not found in localforage.");
        }
      } catch (error) {
        console.error("Error fetching email:", error);
      }
    };
    fetchUserEmail();
  }, []);

  const fetchZoneCount = async () => {
    try {
      const token = await localforage.getItem("token");

      if (selectedZone === initialDropdownValue) {
        console.log("Selected zone is not valid");
        setZoneCount(0);
      } else {
        const responseZoneCount = await api.get(
          `${API_URL}/moms/get-mom-count-by-zone/${selectedZone}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setZoneCount(responseZoneCount.data.momCount);
      }
    } catch (error) {
      console.error("Error fetching zone count:", error);
    }
  };

  useEffect(() => {
    fetchZoneCount();
  }, [selectedZone]);

  const fetchPcCount = async () => {
    try {
      const token = await localforage.getItem("token");

      if (selectedPc === initialDropdownValue) {
        // Set count to 0 or handle accordingly
        console.log("Selected pc is not valid");
        setPcCount(0);
      } else {
        const responsePcCount = await api.get(
          `${API_URL}/moms/get-mom-count-by-pc/${selectedPc}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setPcCount(responsePcCount.data.momCount);
      }
    } catch (error) {
      console.error("Error fetching zone count:", error);
    }
  };

  useEffect(() => {
    fetchPcCount();
  }, [selectedPc]);

  const fetchAcCount = async () => {
    try {
      const token = await localforage.getItem("token");

      if (selectedConstituency === initialDropdownValue) {
        // Set count to 0 or handle accordingly
        console.log("Selected ac is not valid");
        setAcCount(0);
      } else {
        const responseAcCount = await api.get(
          `${API_URL}/moms/get-mom-count-by-constituency/${selectedConstituency}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAcCount(responseAcCount.data.momCount);
        console.log("responseAcCount::: ", responseAcCount);
      }
    } catch (error) {
      console.error("Error fetching zone count:", error);
    }
  };

  useEffect(() => {
    fetchAcCount();
  }, [selectedConstituency]);

  useEffect(() => {
    fetchZoneCount();
    fetchPcCount();
    fetchAcCount();
  }, [selectedZone, selectedPc, selectedConstituency]);

  const sortedMomData = useMemo(() => {
    let sortableMomData = [...momData];
    if (sortConfig.key) {
      sortableMomData.sort((a, b) => {
        if (sortConfig.key === "dom" || sortConfig.key === "createdAt") {
          const dateA = new Date(a[sortConfig.key]);
          const dateB = new Date(b[sortConfig.key]);

          if (sortConfig.direction === "asc") {
            return dateA - dateB;
          } else {
            return dateB - dateA;
          }
        } else {
          const valA = a[sortConfig.key].toUpperCase();
          const valB = b[sortConfig.key].toUpperCase();

          if (sortConfig.direction === "asc") {
            return valA.localeCompare(valB);
          } else {
            return valB.localeCompare(valA);
          }
        }
      });
    }
    return sortableMomData;
  }, [momData, sortConfig]);

  const [dropdownData, setDropdownData] = useState({
    pc: [],
    zone: [],
    districts: [],
    ac: [],
  });

  useEffect(() => {
    const uniqueZone = [...new Set(data.map((item) => item["Zone"]))];
    const uniqueDistricts = [...new Set(data.map((item) => item["District"]))];
    const uniquePc = [
      ...new Set(data.map((item) => item["Pc Name and Number"])),
    ];
    const uniqueAc = [
      ...new Set(data.map((item) => item["Ac Name and Number"])),
    ];

    setDropdownData({
      zone: uniqueZone,
      districts: uniqueDistricts,
      pc: uniquePc,
      ac: uniqueAc,
    });
  }, []);

  const handlePcChange = (e) => {
    const selectedPc = e.target.value;

    const filteredAc = data
      .filter((item) => item["Pc Name and Number"] === selectedPc)
      .map((item) => item["Ac Name and Number"]);

    setDropdownData({
      ...dropdownData,
      ac: [...new Set(filteredAc)],
    });
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    setMomData([]);

    if (name === "pc") {
      try {
        const token = await localforage.getItem("token");

        if (value === initialDropdownValue) {
          setFilteredMomData(sortedMomData);
        } else {
          const responseMomByPC = await api.get(
            `${API_URL}/report/get-report-by-pc/${value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          setMomData(responseMomByPC.data.moms);
          setFilteredMomData(responseMomByPC.data.moms);
        }
      } catch (error) {
        console.error("Error fetching mom data by PC:", error);
      }
    } else if (name === "constituency") {
      try {
        const token = await localforage.getItem("token");

        if (value === initialDropdownValue) {
          setFilteredMomData(sortedMomData);
        } else {
          const responseMomByConstituency = await api.get(
            `${API_URL}/report/get-report-by-constituency/${value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          setMomData(responseMomByConstituency.data.moms);
          setFilteredMomData(responseMomByConstituency.data.moms);
        }
      } catch (error) {
        console.error("Error fetching report data by constituency:", error);
      }
    } else if (name === "zone") {
      try {
        const token = await localforage.getItem("token");

        if (value === initialDropdownValue) {
          setFilteredMomData(sortedMomData);
        } else {
          const responseMomByZone = await api.get(
            `${API_URL}/report/get-report-by-zone/${value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          setMomData(responseMomByZone.data.moms);
          setFilteredMomData(responseMomByZone.data.moms);
        }
      } catch (error) {
        console.error("Error fetching report data by zone:", error);
      }
    }
  };

  const handleDeleteMom = async (momId) => {
    try {
      const token = await localforage.getItem("token");
      await api.delete(`${API_URL}/report/delete-report/${momId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const updatedMomData = momData.filter((mom) => mom._id !== momId);
      setMomData(updatedMomData);
      setFilteredMomData(updatedMomData);
      window.alert("report is deleted successfully");
      window.location.reload();
    } catch (error) {
      console.error("Error deleting mom:", error);
    }
  };

  const formatIndianDate = (date) => {
    if (!date) return "";

    if (!(date instanceof Date)) {
      date = new Date(date);
    }

    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    };

    return date.toLocaleDateString("en-IN", options);
  };

  const allowedRoles = [
    "admin",
    "mod",
    "soul",
    "state",
    "Eastern Vidarbha",
    "Konkan",
    "Marathwada",
    "Mumbai",
    "Northern Maharashtra",
    "Thane + Palghar",
    "Western Maharashtra",
    "Western Vidarbha",
  ];

  const isRoleAllowed = allowedRoles.includes(role);

  useEffect(() => {
    const fetchDocumentCount = async () => {
      try {
        const token = await localforage.getItem("token");

        const response = await api.get(`${API_URL}/report/count-documents`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setDocumentCount(response.data.count);
        console.log("response::: ", response);
      } catch (error) {
        console.error("Error fetching document count:", error);
      }
    };

    const fetchForm20DocumentCount = async () => {
      try {
        const token = await localforage.getItem("token");

        const response = await api.get(
          `${API_URL}/report/count-form20-documents`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setForm20DocumentCount(response.data.count);
      } catch (error) {
        console.error("Error fetching form20Document count:", error);
      }
    };

    fetchDocumentCount();
    fetchForm20DocumentCount();
  }, []);

  useEffect(() => {
    // Update filtered document counts whenever filteredMomData changes
    const updateFilteredCounts = () => {
      const filteredDocsCount = filteredMomData.reduce((acc, mom) => {
        if (mom.document) acc++;
        return acc;
      }, 0);
      const filteredForm20Count = filteredMomData.reduce((acc, mom) => {
        if (mom.form20Document) acc++;
        return acc;
      }, 0);

      setFilteredDocumentCount(filteredDocsCount);
      setFilteredForm20DocumentCount(filteredForm20Count);
    };

    updateFilteredCounts();
  }, [filteredMomData]);

  return (
    <>
      <DashboardReport />
      <div className="mom-container">
        {loading ? (
          <div>
            <BeatLoader color="#03b3ff" className="loader" />
          </div>
        ) : momData.length === 0 ? (
          <div>
            <p>No MOM data available.</p>
          </div>
        ) : (
          <>
            <div className="mom-count">
              <div className="select-columns">
                <label>
                  Zone
                  <select
                    name="zone"
                    value={selectedZone}
                    onChange={(e) => {
                      setSelectedZone(e.target.value);
                      handleInputChange(e);
                    }}
                    style={{ margin: "5px" }}
                    disabled={!isRoleAllowed}
                  >
                    <option value={initialDropdownValue}>Select Zone</option>
                    {dropdownData.zone.map((zone) => (
                      <option key={zone} value={zone}>
                        {zone}
                      </option>
                    ))}
                  </select>
                </label>
                <label>
                  Parliament Constituency
                  <select
                    name="pc"
                    value={selectedPc}
                    onChange={(e) => {
                      setSelectedPc(e.target.value);
                      handlePcChange(e);
                      handleInputChange(e);
                    }}
                    style={{ margin: "5px" }}
                    disabled={!isRoleAllowed}
                  >
                    <option value={initialDropdownValue}>Select PC</option>
                    {dropdownData.pc
                      .sort((a, b) => {
                        // Extract the numeric part of the constituency by splitting and trimming
                        const numberA = parseInt(a.split("-")[0].trim(), 10);
                        const numberB = parseInt(b.split("-")[0].trim(), 10);

                        // Compare and sort numerically
                        return numberA - numberB;
                      })
                      .map((parliament) => (
                        <option key={parliament} value={parliament}>
                          {parliament}
                        </option>
                      ))}
                  </select>
                </label>
                <label>
                  Assembly Constituency
                  <select
                    name="constituency"
                    value={selectedConstituency}
                    onChange={(e) => {
                      setSelectedConstituency(e.target.value);
                      handleInputChange(e);
                    }}
                    style={{ margin: "5px" }}
                  >
                    <option value={initialDropdownValue}>Select AC</option>
                    {dropdownData.ac
                      .sort((a, b) => {
                        // Extract the names from the assembly strings (after the hyphen)
                        const nameA = a.split("-")[1].trim().toLowerCase();
                        const nameB = b.split("-")[1].trim().toLowerCase();

                        // Perform alphabetical sorting on names
                        return nameA.localeCompare(nameB);
                      })
                      .map((assembly) => {
                        // Split the assembly string into two parts
                        const [number, name] = assembly.split("-");
                        // Capitalize the first letter of the name
                        const capitalizedAssembly = `${number}-${
                          name.charAt(0).toUpperCase() + name.slice(1)
                        }`;
                        return (
                          <option key={assembly} value={assembly}>
                            {capitalizedAssembly}
                          </option>
                        );
                      })}
                  </select>
                </label>
                {location === "Andhra Pradesh" ? null : (
                  <label>
                    Search
                    <input
                      type="text"
                      placeholder="Search by Leader's Name"
                      value={searchInput}
                      onChange={handleSearchInputChange}
                      style={{ margin: "5px" }}
                    />
                  </label>
                )}
              </div>
              <div
                className="select-columns"
                style={{
                  padding: "20px",
                  display: "flex",
                  justifyContent: "space-evenly",
                  fontSize: "20px",
                }}
              >
                <div className="total-count" style={{ margin: "5px" }}>
                  <h3>Total Reports Count: </h3>
                  <h6>{responseAllMomCount}</h6>
                  <h3> Total AC Reports: </h3>
                  <h6>{filteredDocumentCount}</h6> {/* Updated line */}
                  {location === "Andhra Pradesh" ? null : (
                    <>
                      <h3>Total Form-20: </h3>
                      <h6>{filteredForm20DocumentCount}</h6>
                    </>
                  )}
                  {/* Updated line */}
                </div>
              </div>
            </div>
            <div class="table-container">
              <table className="mom-table">
                <thead>
                  <tr>
                    {/* <th>PCM Name</th> */}

                    <th
                      onClick={() => requestSort("constituency")}
                      className={getClassNamesFor("constituency")}
                    >
                      District{" "}
                      {getClassNamesFor("constituency") === "asc" && "↑"}
                      {getClassNamesFor("constituency") === "desc" && "↓"}
                    </th>
                    <th
                      onClick={() => requestSort("leaderName")}
                      className={getClassNamesFor("leaderName")}
                    >
                      Parliamentary Constituency{" "}
                      {getClassNamesFor("leaderName") === "asc" && "↑"}
                      {getClassNamesFor("leaderName") === "desc" && "↓"}
                    </th>

                    <th
                      onClick={() => requestSort("dom")}
                      className={getClassNamesFor("dom")}
                    >
                      Assembly Constituency{" "}
                      {getClassNamesFor("dom") === "asc" && "↑"}
                      {getClassNamesFor("dom") === "desc" && "↓"}
                    </th>
                    {/* <th
                      onClick={() => requestSort("dom")}
                      className={getClassNamesFor("dom")}
                      style={{ textAlign: "left" }}
                    >
                      Created Date {getClassNamesFor("dom") === "asc" && "↑"}
                      {getClassNamesFor("dom") === "desc" && "↓"}
                    </th> */}
                    {/* <th
                      onClick={() => requestSort("dom")}
                      className={getClassNamesFor("dom")}
                    >
                      Last Updated {getClassNamesFor("dom") === "asc" && "↑"}
                      {getClassNamesFor("dom") === "desc" && "↓"}
                    </th> */}
                    <th style={{ textAlign: "center" }}>AC Level Reports</th>
                    {location === "Andhra Pradesh" ? (
                      <th style={{ textAlign: "center" }}>PC MoM</th>
                    ) : (
                      <th style={{ textAlign: "center" }}>Download</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {displayedMomData.map((mom) => (
                    <tr key={mom.id}>
                      {/* <td>{mom.userId.userName}</td> */}
                      <td>{mom.district}</td>
                      <td>{mom.pc}</td>
                      <td>{mom.constituency}</td>
                      {/* <td>{formatIndianDate(mom.createdAt)}</td> */}
                      {/* <td>{formatIndianDate(mom.updatedAt)}</td> */}
                      <td className="td-extra">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column-reverse",
                            alignItems: "center",
                          }}
                        >
                          {role !== "mod" ? null : (
                            <button
                              onClick={() => handleDeleteMom(mom._id)}
                              style={{
                                width: "fit-content",
                                backgroundColor: "red",
                              }}
                            >
                              Delete
                            </button>
                          )}

                          {role !== "mod" &&
                          role !== "soul" &&
                          email !== "aditiambekar@showtimeconsulting.in" &&
                          email !== "sagar.jadhav@showtimeconsulting.in" &&
                          email !== "pratikubale@showtimeconsulting.in" &&
                          email !== "akash.jaywant@showtimeconsulting.in" &&
                          email !== "kaustavv.das@showtimeconsulting.in" &&
                          email !== "somali@showtimeconsulting.in" &&
                          email !==
                            "govind.lilhare@showtimeconsulting.in" ? null : (
                            <Link
                              to={`/update-report/${mom._id}`}
                              style={{
                                textDecoration: "none",
                                padding: "5px 0px",
                                color: "#008cff",
                              }}
                            >
                              Update
                            </Link>
                          )}

                          {location ===
                          "Maharashtra" ? null : mom.acVsCubReports ? (
                            <a
                              href={mom.acVsCubReports}
                              download={`Document_of_${mom.leaderName}.pdf`}
                              className="download-link"
                              target="_blank"
                              style={{ color: "#008cff" }}
                              rel="noopener noreferrer"
                            >
                              AC vs CUB Report
                            </a>
                          ) : (
                            <span>No Document</span>
                          )}

                          {mom.document ? (
                            <a
                              href={mom.document}
                              download={`Document_of_${mom.leaderName}.pdf`}
                              className="download-link"
                              target="_blank"
                              style={{ color: "#008cff" }}
                              rel="noopener noreferrer"
                            >
                              {location === "Andhra Pradesh"
                                ? "AC Dockets"
                                : "View"}
                            </a>
                          ) : (
                            <span>No Document</span>
                          )}

                          {location ===
                          "Maharashtra" ? null : mom.apAcReports ? (
                            <a
                              href={mom.apAcReports}
                              download={`Document_of_${mom.leaderName}.pdf`}
                              className="download-link"
                              target="_blank"
                              style={{ color: "#008cff" }}
                              rel="noopener noreferrer"
                            >
                              Retro Report
                            </a>
                          ) : (
                            <span>No Document</span>
                          )}
                        </div>
                      </td>
                      {location === "Andhra Pradesh" ? (
                        <td className="td-extra">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column-reverse",
                              alignItems: "center",
                            }}
                          >
                            {mom.pcMom && (
                              <a
                                href={mom.pcMom}
                                download={`Document_of_${mom.leaderName}.pdf`}
                                className="download-link"
                                target="_blank"
                                style={{ color: "#008cff" }}
                                rel="noopener noreferrer"
                              >
                                PC - MoM
                              </a>
                            )}
                          </div>
                        </td>
                      ) : (
                        <td className="td-extra">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column-reverse",
                              alignItems: "center",
                            }}
                          >
                            {/* {role !== "mod" ? null : (
                            <button
                              onClick={() => handleDeleteMom(mom._id)}
                              style={{
                                width: "fit-content",
                                backgroundColor: "red",
                              }}
                            >
                              Delete
                            </button>
                          )} */}
                            {mom.form20Document && (
                              <a
                                href={mom.form20Document}
                                download={`Document_of_${mom.leaderName}.pdf`}
                                className="download-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#008cff" }}
                              >
                                Form-20
                              </a>
                            )}
                            {mom.boothReport && (
                              <a
                                href={mom.boothReport}
                                download={`Document_of_${mom.leaderName}.pdf`}
                                className="download-link"
                                target="_blank"
                                style={{ color: "#008cff" }}
                                rel="noopener noreferrer"
                              >
                                Booth Report
                              </a>
                            )}
                            {/* <Link
                            to={`/update-report/${mom._id}`}
                            style={{
                              textDecoration: "none",
                              padding: "5px 0px",
                              color: "#008cff",
                            }}
                          >
                            Update
                          </Link> */}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>

              <ReactPaginate
                pageCount={pageCount}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                previousLabel={"previous"}
                nextLabel={"next"}
                breakLabel={"..."}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Report;
